/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createPageSlice = (set) => ({
  loadingEmailsPreferences: false,
  loadingTemplateEmail: false,
  loadingSaveChanges: false,
  emailsPreferences: null,
  emailData: {
    // if the value exists on db, it will set the id and type here
    'select-return-method': {
      mode: 'default',
      subject: '',
      html: '',
    },
    'cliqueretire-approved': {
      mode: 'default',
      subject: '',
      html: '',
    },
    'correios-approved': {
      mode: 'default',
      subject: '',
      html: '',
    },
  },
  fetchedData: {
    emailsPreferences: null,
    'select-return-method': null,
    'cliqueretire-approved': null,
    'correios-approved': null,
  },
  setEmailData: (data, type) => {
    set(
      produce((draft) => {
        draft.emailData[type] = data;
      }),
    );
  },
  setMode: (mode, type) => {
    set(
      produce((draft) => {
        draft.emailData[type].mode = mode;
      }),
    );
  },
  setSubject: (subject, type) => {
    set(
      produce((draft) => {
        draft.emailData[type].subject = subject;
      }),
    );
  },
  setHtml: (html, type) => {
    set(
      produce((draft) => {
        draft.emailData[type].html = html;
      }),
    );
  },
  setFetchedData: (data, type) => {
    set(
      produce((draft) => {
        draft.fetchedData[type] = data;
      }),
    );
  },
  setLoadingEmailsPreferences: (loadingEmailsPreferences) => {
    set(
      produce((draft) => {
        draft.loadingEmailsPreferences = loadingEmailsPreferences;
      }),
    );
  },
  setLoadingTemplateEmail: (loadingTemplateEmail) => {
    set(
      produce((draft) => {
        draft.loadingTemplateEmail = loadingTemplateEmail;
      }),
    );
  },
  setLoadingSaveChanges: (loadingSaveChanges) => {
    set(
      produce((draft) => {
        draft.loadingSaveChanges = loadingSaveChanges;
      }),
    );
  },
  setEmailsPreferences: (emailsPreferences) => {
    set(
      produce((draft) => {
        draft.emailsPreferences = emailsPreferences;
      }),
    );
  },
  setSenderEmail: (senderEmail) => {
    set(
      produce((draft) => {
        if (draft.emailsPreferences) {
          draft.emailsPreferences.senderEmail = senderEmail;
        } else {
          draft.emailsPreferences = {
            senderEmail,
            senderName: null,
          };
        }
      }),
    );
  },
  setSenderName: (senderName) => {
    set(
      produce((draft) => {
        if (draft.emailsPreferences) {
          draft.emailsPreferences.senderName = senderName;
        } else {
          draft.emailsPreferences = {
            senderName,
            senderEmail: null,
          };
        }
      }),
    );
  },
});

const usePageStore = create(
  devtools(
    (...a) => ({
      ...createPageSlice(...a),
    }),
    { name: 'Emails' },
  ),
);

export default usePageStore;
